<template>
  <div>
    <reaction
      v-for="(reaction, reactionType) in reactions"
      :key="reactionType"
      :reaction="reaction"
      :reactionType="reactionType"
      :reactableType="reactableType"
      :reactableId="reactableId"
      v-if="reaction.count > 0"
      @click="toggleReaction(reactionType)"
    ></reaction>
    <reaction-add-tooltip
      :reactions="reactions"
      @toggle="toggleReaction"
      :tooltipVisible="tooltipVisible"
      v-if="canReact"
      ref="tooltip"
    >
      <a
        class="reaction reactions__add"
        @click.prevent="toggleReactionTooltip"
        :class="{ 'reactions__add--active': tooltipVisible }"
        href="#"
        ><span class="">+</span><span class="far fa-smile"></span
      ></a>
    </reaction-add-tooltip>
  </div>
</template>

<script>
import api from './api'
import ReactionAddTooltip from "./ReactionAddTooltip";
import Reaction from "./Reaction";
export default {
  name: "Reactions",
  components: {
    ReactionAddTooltip,
    Reaction
  },
  props: ["reactableId", "reactableType", "canReact", "single"],
  data () {
    return {
      reactions: {
        like: {
          count: 0,
          active: false,
          className: "emoji-like"
        },
        heart: {
          count: 0,
          active: false,
          className: "emoji-heart"
        },
        laugh: {
          count: 0,
          active: false,
          className: "emoji-laugh"
        },
        frown: {
          count: 0,
          active: false,
          className: "emoji-frown"
        },
        surprise: {
          count: 0,
          active: false,
          className: "emoji-wow"
        }
      },
      tooltipVisible: false
    };
  },
  computed: {
    storeKey () {
      if (this.single) {
        return this.reactableType;
      }

      return this.reactableType + "_" + this.reactableId;
    }
  },
  mounted () {
    let currentPostReactions = Grabcad.store[this.storeKey].reactions;

    Object.keys(currentPostReactions).forEach((key) => {
      let reaction = currentPostReactions[key],
        localReaction = this.reactions[key];
      localReaction.count = reaction.count;
      localReaction.active = reaction.active;
    });
  },
  methods: {
    toggleReactionTooltip () {
      this.tooltipVisible = !this.tooltipVisible;
    },

    closeReactionTooltip () {
      this.tooltipVisible = false;
    },

    isActive (reactionType) {
      return this.reactions[reactionType].active;
    },

    toggleReaction (reactionType) {
      if (!this.canReact) return;

      this.closeReactionTooltip();
      let requestDataObj = {};
      let requestType = this.isActive(reactionType) ? "delete" : "post";
      requestDataObj[this.reactableType + "_id"] = this.reactableId;

      let requestParams = {
        url: "/reactions/" + reactionType,
        data: requestDataObj,
        method: requestType
      };

      this.updateReaction(reactionType, requestType);
      api.api.request(requestParams).catch(this.requestError);
    },

    handleClicksOutsideTooltip (event) {
      let el = this.$refs.tooltip.$el;

      if (el && !el.contains(event.target)) {
        this.tooltipVisible = false;
      }
    },

    updateReaction (reactionType, action) {
      let reaction = this.reactions[reactionType];
      if (action === "delete") {
        reaction.count--;
        reaction.active = false;
      } else {
        reaction.count++;
        reaction.active = true;
      }
    },

    requestError () {
      // No handling for now
    }
  },
  watch: {
    tooltipVisible (newValue) {
      if (newValue) {
        document.addEventListener("click", this.handleClicksOutsideTooltip);
      } else {
        document.removeEventListener("click", this.handleClicksOutsideTooltip);
      }
    }
  }
};
</script>
